<div class="body" [class.error]="!((folder$|async)?.length > 0)">

    <app-nextcloud-explorer 
        *ngIf="!error; else errorTemplate" 
        [files]="folder$|async" 
        [loading]="loading$|async" 
        [enableNavigation]="true" 
        [view]="view" 
        (onFileClick)="previewFile(null, $event)"
    ></app-nextcloud-explorer>

</div>

<ng-template #errorTemplate>

    <div class="error-wrapper">

        {{error}}

    </div>

</ng-template>
